import { createAsyncThunk } from '@reduxjs/toolkit';
import { getParams } from '../common/get-params';

let drilldownControllerRef = null;

const getHireCard = async (
  { timeFrame = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, filters, compare: true });
  const hireCardResponse = atsHttp.post(`/reports/hires/card`, params);
  return hireCardResponse;
};

const getHireTableAndChart = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(`/reports/hires/chart_table`, params);
  return hireCardResponse;
};

const getHireVisual = async (
  { timeFrame = {}, group = {}, filters = {} },
  { extra: { atsHttp } }
) => {
  const params = getParams({ timeFrame, group, filters });
  const hireCardResponse = atsHttp.post(`/reports/hires/visual`, params);
  return hireCardResponse;
};

const getHireDrilldown = async (
  { timeFrame = {}, group = {}, filters = {}, drilldown = {} },
  { extra: { atsHttp } }
) => {
  if (drilldownControllerRef) {
    drilldownControllerRef.abort();
  }

  // Create a new controller for this request
  const controller = new AbortController();
  drilldownControllerRef = controller;
  try {
    const params = getParams({
      timeFrame,
      group,
      filters,
      drilldown,
      compare: false,
    });
    const response = await atsHttp.post(`/reports/hires/drilldown`, params, {
      signal: controller.signal,
    });
    return response;
  } catch (error) {
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      throw error;
    }
    throw error;
  }
};

export const fetchHireCard = createAsyncThunk(
  'ats-reports/hire/card',
  getHireCard
);

export const fetchHireTableAndChart = createAsyncThunk(
  'ats-reports/hire/table-chart',
  getHireTableAndChart
);

export const fetchHireDepartmentVisual = createAsyncThunk(
  'ats-reports/hire/department/visual',
  getHireVisual
);

export const fetchHireSourceVisual = createAsyncThunk(
  'ats-reports/hire/department/source',
  getHireVisual
);

export const fetchHireDrilldown = createAsyncThunk(
  'ats-reports/hires/drilldown',
  getHireDrilldown
);
